export default {
  all: {},
  foundUser: [],
}
